var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Ghbhtnds = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E9EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.615 22.68V16.095C37.615 14.865 36.685 13.47 35.53 13.005L27.175 9.58498C25.3 8.81998 23.185 8.81998 21.31 9.58498L12.955 13.005C11.815 13.47 10.885 14.865 10.885 16.095V22.68C10.885 30.015 16.21 36.885 23.485 38.895C23.98 39.03 24.52 39.03 25.015 38.895C32.29 36.885 37.615 30.015 37.615 22.68Z",
    fill: "url(#paint0_linear_47_1155)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.95 25.5C17.7015 25.5 17.5 25.2985 17.5 25.05V22.9617C17.5 22.7132 17.7015 22.5117 17.95 22.5117H22.032C22.2806 22.5117 22.482 22.3102 22.482 22.0617V17.7C22.482 17.4515 22.6835 17.25 22.932 17.25H25.5541C25.8027 17.25 26.0041 17.4515 26.0041 17.7V22.0617C26.0041 22.3102 26.2056 22.5117 26.4541 22.5117H30.55C30.7985 22.5117 31 22.7132 31 22.9617V25.05C31 25.2985 30.7985 25.5 30.55 25.5H26.4541C26.2056 25.5 26.0041 25.7015 26.0041 25.95V30.3C26.0041 30.5485 25.8027 30.75 25.5541 30.75H22.932C22.6835 30.75 22.482 30.5485 22.482 30.3V25.95C22.482 25.7015 22.2806 25.5 22.032 25.5H17.95Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_1155",
    x1: 10.885,
    y1: 21.7549,
    x2: 37.615,
    y2: 21.7549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Ghbhtnds, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2ghbhtnds.9b4a7158.svg";
export { ForwardRef as ReactComponent };